var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.0766517 7.77703C-0.0255506 8.02567 -0.0255506 8.30431 0.0766517 8.55296C1.96002 13.1154 6.45489 16.33 11.6947 16.33C16.9349 16.33 21.4293 13.1154 23.3127 8.55296C23.4149 8.30431 23.4149 8.02567 23.3127 7.77703C21.4293 3.21454 16.9349 0 11.6947 0C6.45489 0 1.96002 3.21454 0.0766517 7.77703ZM2.12629 8.16499C3.79356 4.54775 7.45301 2.03388 11.6947 2.03388C15.9368 2.03388 19.5958 4.54775 21.263 8.16448C19.5958 11.7822 15.9368 14.2961 11.6947 14.2961C7.45301 14.2961 3.79356 11.7817 2.12629 8.16499Z",
    fill: "#6479F8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6948 4.52179C9.73057 4.52179 8.1355 6.11686 8.1355 8.08107C8.1355 10.0453 9.73057 11.6404 11.6948 11.6404C13.659 11.6404 15.2541 10.0453 15.2541 8.08107C15.2541 6.11686 13.659 4.52179 11.6948 4.52179ZM11.6948 6.55567C12.5368 6.55567 13.2202 7.23905 13.2202 8.08107C13.2202 8.9231 12.5368 9.60648 11.6948 9.60648C10.8528 9.60648 10.1694 8.9231 10.1694 8.08107C10.1694 7.23905 10.8528 6.55567 11.6948 6.55567Z",
    fill: "#6479F8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueEyeIcon);
export default __webpack_public_path__ + "static/media/blue-eye-icon.9b8b2591abff02d1740e75c72aa5af46.svg";
export { ForwardRef as ReactComponent };